import React, { useState } from "react";
import { useForm, Create } from "@refinedev/antd";
import { useNavigation } from "@refinedev/core";
import { PROCUREMENT_PLAN_CREATE_MUTATION } from "./queries";
import { ProcurementPlanForm } from "./components/ProcurementPlanForm";
import { IProcurementItem, IProcurementPlan } from "./interface";



export const CreateProcurementPlan: React.FC = () => {
  const { formProps, saveButtonProps, onFinish } = useForm<IProcurementPlan>({
    resource: "procurementPlans",
    meta:{
      gqlMutation: PROCUREMENT_PLAN_CREATE_MUTATION,
    }
  });
  
  const [items, setItems] = useState<IProcurementItem[]>([]);
  const { list } = useNavigation();

  // Handle form submission for approval
  const handleSubmit = async (values: any) => {
    await onFinish({
      ...values,
      items,
    });
    list("procurementPlans");
  };

  // Handle saving draft (only validate main form fields)
  const handleSaveDraft = async (values: any) => {
    await onFinish({
      ...values,
      items,
    });
    list("procurementPlans");
  };

  const handleCancel = () => {
    // Handle cancel action
    console.log('Cancelled');
  };

  return (
    <Create
      saveButtonProps={saveButtonProps}
      footerButtons={()=>null}
      title="Create Procurement Plan"
    >
      <ProcurementPlanForm
        form={formProps.form}
        isEdit={false}
        onSaveDraft={handleSaveDraft}
        onSubmitForApproval={handleSubmit}
        onCancel={handleCancel}
        items={items}
        setItems={setItems as any}
      />
    </Create>
  );
};